
export function hasPermission(rolesData, permissionValue) {
    if (!rolesData || !Array.isArray(rolesData)) {
        return false;
    }

    return rolesData.some(role =>
        role.permissions &&
        Array.isArray(role.permissions) &&
        role.permissions.includes(permissionValue)
    );
}